import * as React from "react";
import { forwardRef } from "react";
const SvgCopy = (props, ref) => /* @__PURE__ */ React.createElement("svg", {
	viewBox: "0 0 15 14",
	xmlns: "http://www.w3.org/2000/svg",
	width: "1em",
	height: "1em",
	ref,
	...props
}, /* @__PURE__ */ React.createElement("path", {
	fill: "currentColor",
	d: "M13.203 0h-8.75c-.725 0-1.312.588-1.312 1.313v1.312H1.828c-.725 0-1.312.588-1.312 1.313v8.75c0 .724.587 1.312 1.312 1.312h8.75c.725 0 1.313-.588 1.313-1.313v-1.312h1.312c.725 0 1.313-.588 1.313-1.313v-8.75C14.516.589 13.928 0 13.203 0Zm-2.789 12.688H1.992a.164.164 0 0 1-.164-.165V4.102a.164.164 0 0 1 .164-.165h1.149v6.126c0 .724.587 1.312 1.312 1.312h6.125v1.148a.164.164 0 0 1-.164.165Zm2.625-2.626H4.617a.164.164 0 0 1-.164-.164V1.477a.164.164 0 0 1 .164-.165h8.422a.164.164 0 0 1 .164.165v8.421a.164.164 0 0 1-.164.165Z"
}));
const ForwardRef = forwardRef(SvgCopy);
export default ForwardRef;
